import { ZInput } from "@zanichelli/albe-web-components/react/components";
import i18next from "i18next";
import React from "react";
import { WotdFormData } from "../../../beans/api";
import { IWotdFormDataSet } from "../../store/WotdFormData/actions";
import { Wrap } from "./styles";
import { InputType } from "@zanichelli/albe-web-components";

type Props = {
  checkboxes: null | WotdFormData["words"] | WotdFormData["personalData"];
  handleCheckboxes: (
    checkboxes: WotdFormData["words"] | WotdFormData["personalData"],
  ) => IWotdFormDataSet;
  labels: string[];
};
const CheckboxesComponent: React.FC<Props> = ({
  checkboxes,
  handleCheckboxes,
  labels,
}) => {
  let checkArray = [];
  let index = 0;
  if (checkboxes) {
    for (const [key, value] of Object.entries(checkboxes)) {
      checkArray.push(
        <ZInput
          name={key}
          type={InputType.CHECKBOX}
          label={i18next.t(labels[index])}
          checked={value}
          key={key}
          onInputCheck={() => handleCheckboxes({ [key]: !value })}
        />,
      );
      index++;
    }
  }

  return <Wrap>{checkArray}</Wrap>;
};

export default CheckboxesComponent;
